






















import { MultiResourceMixin } from '@/mixins/multiResourceMixin'
import { Resource } from '@/config/interfaces'
import { darkColors, lightColors } from '@/config/colors'

export default MultiResourceMixin.extend({
  name: 'MsisdnButtonsEl',

  methods: {
    getAppropriateStyle (msisdn: Resource): string {
      let style = ''
      if (msisdn.active) {
        style += 'border-color:' + (this.$vuetify.theme.dark ? darkColors.secondary : lightColors.activeBorderColor)
      } else {
        style += 'border-color: lightgrey;'
      }
      return style
    },
    switchResource (resource: Resource) {
      if (resource.active) {
        return
      }
      this.switchIdentifier(resource)
    }
  },

  props: {
    templateItemData: {
      type: Object as () => { msisdns: Array<Resource> },
      required: true
    }
  }
})
